/**
 * DOM 稳定性检测配置
 * 用于判断微应用页面是否真正渲染完成
 */
export default {
  // 初始静默时间（前2秒，快速响应）
  initialStableTime: 100,

  // 扩展静默时间（2秒后，放宽要求）
  extendedStableTime: 500,

  // 分界点（多久后切换到扩展模式）
  modeSwitchTime: 2000,

  // 总超时时间（兜底）
  totalTimeout: 8000,

  // 检测间隔
  checkInterval: 50,

  // 忽略的元素选择器（高频变化的元素）
  // 这些元素会持续更新，不应影响稳定性判断
  ignoredSelectors: [
    // 倒计时和定时器
    '[class*="countdown"]',
    '[class*="timer"]',
    '[class*="time"]',
    'time',
    '.time',
    '#time',

    // Loading 和动画
    '[class*="loading"]',
    '[class*="spinner"]',
    '[class*="skeleton"]',

    // 轮播图
    '[class*="carousel"]',
    '[class*="swiper"]',
    '[class*="slider"]',

    // 实时数据
    '[class*="realtime"]',
    '[class*="refresh"]',
    '[class*="live"]',

    // 进度条和动态值
    '[class*="progress"]',
    '[role="progressbar"]',
    '[class*="counter"]',
  ]
}
